function iqxWebBuildOwnerMenu(menu){
  'use strict';

  menu.addItem({
    id:'iqxWeb_menu_home',
    title:'Home',
    icon:'fas fa-home',
    url:'/home'
  })

  menu.addItem({
    id:'iqxWeb_menu_favourites',
    title:'Favourites',
    icon:'fas fa-heart',
    url:'/favourites',
    rights:'FAVOURITES'
  })

  menu.addItem({
    id:'iqxWeb_menu_analytics',
    title:'IQX Analytics',
    icon:'fas fa-chart-bar',
    url:'/dashboard'
  })

  menu.addItem({
    id:'iqxWeb_menu_diary',
    title:'Diary',
    icon:'fas fa-calendar',
    url:'/consultantDiary',
    rights:'CONSULTANTDIARY'
  })

  menu.addDropdown({
    id:'iqxWeb_menu_search',
    title:'Search',
    icon:'fas fa-search',
    rights:'SEARCH'
  })
    .subMenu
      .addItem({
        id:'iqxWeb_menu_candidates',
        title:'Candidates',
        url:'/search/candidates'
      })
      .addItem({
        id:'iqxWeb_menu_companies',
        title:'Companies',
        url:'/search/companies'
      })
      .addItem({
        id:'iqxWeb_menu_contacts',
        title:'Contacts',
        url:'/search/contacts'
      })

  menu.addItem({
    id:'iqxWeb_menu_hubStats',
    title:'Hub Stats',
    icon:'fas fa-server',
    url:'/serverstats',
    rights:'HUBSTATS'
  })

  menu.addItem({
    id:'iqxWeb_menu_sms',
    title:'SMS',
    icon:'fas fa-comments',
    url:'/sms',
    rights:'SMS'
  })

  menu.addItem({
    id:'iqxWeb_menu_pageElements',
    title:'Page Elements',
    icon:'fas fa-paint-brush',
    url:'/elements',
    rights:'APIDESIGN',
    switches:'APIDESIGN'
  })

  menu.addItem({
    id:'iqxWeb_menu_reports',
    title:'Reports',
    icon:'fas fa-chart-pie',
    url:'/reports',
    rights:'MANAGEMENTINFO'
  })

  menu.addSplitter({
    id:'iqxWeb_menu_splitter'
  })

  menu.addItem({
    id:'iqxWeb_menu_settings',
    title:'Settings',
    icon:'fas fa-cog',
    url:'/settings'
  })

  menu.addItem({
    id:'iqxWeb_menu_help',
    title:'Help',
    icon:'fas fa-question-circle',
    url:'/help',
    switches:'SHOWFAQPAGE'
  })

  menu.addLogoutButton({
    id:'iqxWeb_menu_logout',
    title:'Logout',
    icon:'fas fa-sign-out-alt',
    click:'logout()',
    switches:'OWNER_LOGOUT_NAV'
  })

}
